import { useSearchParams, Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

export default function AuthError() {
  const [params] = useSearchParams();
  const message = params.get("message") || "Authentication failed";

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-white" data-testid="auth-error">
      <div className="surface p-10 max-w-xl w-full">
        <AlertTriangle className="w-8 h-8 text-[#FF4F00] mb-4" />
        <h1 className="font-display font-black text-3xl tracking-tighter mb-3 text-zinc-900">
          Login failed
        </h1>
        <p className="font-mono text-xs text-zinc-500 break-all mb-6">{message}</p>
        <Link to="/" className="btn-ghost inline-block" data-testid="auth-error-back">
          ← Back home
        </Link>
      </div>
    </div>
  );
}
